import React, { memo } from "react";
import { formatCurrency } from "./format-currency";
import { useMediaQuery } from "react-responsive";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.compat.css";
import cleanURL from "./cleanURL";
import { Link } from "react-router-dom";

interface prop {
  item?: any;
  index?: number;
  is_slider: boolean;
  onClickItem: any;
  custom_style?: any;
  divWidth?: any;
  prodLength?: any;
  from?: String;
}

function RenderItem(props: prop) {
  let { item, index, is_slider, divWidth, prodLength } = props;
  let price = item.Price.toString().includes("$")
    ? item.Price
    : formatCurrency(item.Price);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  // let isTrending = ""
  // let isTrending = item.CustomFields ? item.CustomFields.filter((response => response.Name.includes("trending"))).length > 0 ? item.CustomFields.filter((response => response.Name.includes("trending")))[0].Values[0] : "" : "";;
  let originalPrice = "";
  originalPrice = item.CustomFields
    ? item.CustomFields.filter((response) =>
        response.Name.includes("ORIGINAL PRICE (BEFORE DISCOUNT)")
      ).length > 0
      ? item.CustomFields.filter((response) =>
          response.Name.includes("ORIGINAL PRICE (BEFORE DISCOUNT)")
        )[0].Values[0]
      : ""
    : "";

  if (originalPrice !== "") {
    item.OriginalPrice = originalPrice;
  }
  let isSale =
    item.AddOns && item.AddOns.length > 0
      ? item.OriginalPrice
        ? true
        : false
      : item.StockLimited
      ? item.StockQuantity > 0
        ? item.OriginalPrice
          ? true
          : false
        : true
      : false;

  const BrandName = item.CustomFields
    ? item.CustomFields.length > 0
      ? item.CustomFields.filter((item) => item.Name.includes("Brand")).length >
        0
        ? item.CustomFields.filter((item) => item.Name.includes("Brand"))[0]
            .Values[0]
        : ""
      : ""
    : "";
  return (
    <>
      {is_slider ? (
        <Link
          key={index}
          to={{
            pathname: `/product/${cleanURL(item.Name)}/${item.ID}`,
            state: props.from,
          }}
          className="slider-item"
          // onClick={(e) => {
          //     props.onClickItem(item)
          // }}
        >
          <div className={"product"}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                border: "1px solid #ccc",
                alignItems: "flex-start",
              }}
            >
              <img src={item?.Media[0]?.MediaUrl} />
            </div>
            <div
              className={"shopname"}
              style={{ marginTop: 15, marginBottom: 1, color: "#333" }}
            >
              {BrandName}
            </div>
            <div
              className={"productname"}
              style={{ marginBottom: 15, color: "#666" }}
            >
              {item.Name}
            </div>
            <div>
              {!item.OriginalPrice ? (
                <div
                  className={`price ${isSale ? "sale" : ""}`}
                  style={{ color: "#333" }}
                >
                  {item?.HasChildItems === true ||
                  item?.StockLimited == false ||
                  item?.StockQuantity >= 1 ? (
                    price
                  ) : (
                    <div className="sale">Sold out</div>
                  )}
                </div>
              ) : (
                <>
                  {item.OriginalPrice && (
                    <div
                      className="price"
                      style={{ display: "flex", flexDirection: "row" }}
                    >
                      <div className="up" style={{ color: "red" }}>
                        {price}
                      </div>
                      <div
                        className="sale"
                        style={{
                          textDecoration: "line-through",
                          marginLeft: 5,
                          color: "#333",
                        }}
                      >
                        {formatCurrency(item?.OriginalPrice)}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </Link>
      ) : (
        //without Slider
        <Link
          key={index}
          className="item"
          to={{
            pathname: `/product/${cleanURL(item.Name)}/${item.ID}`,

            state: props.from,
          }}
          // onClick={(e) => {
          //     e.preventDefault();
          //     props.onClickItem(item);
          // }}
        >
          <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
            <div className="thumb" style={{ border: "1px solid #ccc" }}>
              <img src={item?.Media[0]?.MediaUrl} />
            </div>
            <div className="brand">{BrandName.replace(/&amp;/g, "&")}</div>
            <div className="name">{item?.Name}</div>
            {!item.OriginalPrice ? (
              <div
                className={`price ${isSale ? "sale" : ""}`}
                style={{ color: "#333" }}
              >
                {item?.HasChildItems === true ||
                item?.StockLimited == false ||
                item?.StockQuantity >= 1 ? (
                  price
                ) : (
                  <div className="sale">Sold out</div>
                )}
              </div>
            ) : (
              <>
                {item.OriginalPrice && (
                  <div className="price">
                    <div className="sale">{price}</div>
                    <div className="up">
                      {formatCurrency(item.OriginalPrice)}
                    </div>
                  </div>
                )}
              </>
            )}
          </ScrollAnimation>
        </Link>
      )}
    </>
  );
}
export default memo(RenderItem);
